import React from 'react';
import { Toast } from 'react-bootstrap';

interface Props {
	onClose: () => void,
	visible: boolean,
	text: string
}

const _Toast = (props: Props) => (
	<div className="toast-component">
		<Toast show={ props.visible } onClose={ props.onClose } delay={ 3000 } autohide>
          <Toast.Body>{ props.text }</Toast.Body>
        </Toast>
    </div>
)

export default _Toast;